'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioField = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioField = exports.RadioField = function RadioField(_ref) {
  var label = _ref.label,
      input = _ref.input,
      meta = _ref.meta,
      wrapperAttributes = _ref.wrapperAttributes,
      wrapperTag = _ref.wrapperTag,
      suppressErrorMessage = _ref.suppressErrorMessage,
      options = _ref.options;

  var fieldId = input.name + '_field';
  var hasError = meta.error && meta.touched && !meta.active;

  var classes = {
    'form__input--error': hasError
  };

  var inputElements = (0, _keys2.default)(options).map(function (option) {
    return _react2.default.createElement(
      _react.Fragment,
      { key: option },
      _react2.default.createElement('input', (0, _extends3.default)({}, input, {
        className: (0, _classnames2.default)(classes),
        type: 'radio',
        id: fieldId + '_' + option,
        checked: option === input.value,
        value: option
      })),
      _react2.default.createElement(
        'label',
        { htmlFor: fieldId + '_' + option, className: 'form__label--no-style' },
        options[option]
      )
    );
  });

  return _react2.default.createElement(wrapperTag || 'div', wrapperAttributes || {}, label ? _react2.default.createElement(
    'label',
    { htmlFor: fieldId },
    label
  ) : null, _react2.default.createElement(
    'div',
    { className: 'form__radio' },
    inputElements
  ), hasError && !suppressErrorMessage ? _react2.default.createElement(
    'div',
    { className: 'error__text text--sm mt-' },
    meta.error
  ) : null);
};

RadioField.propTypes = {
  input: _propTypes2.default.object,
  meta: _propTypes2.default.object,
  label: _propTypes2.default.element,
  suppressErrorMessage: _propTypes2.default.bool,
  wrapperAttributes: _propTypes2.default.object,
  wrapperTag: _propTypes2.default.string,
  options: _propTypes2.default.object
};